/**
 * This is made for the use of the correct URLs and these are also used in the URL for calling the correct URLs in the permission API calls.
 */
export enum LevelEnum {
    OrganisationLevel = 'organisation',
    WhitelabelLevel = "whitelabel",
    SystemLevel = 'system',
}